import { BaseContainerModel } from '../../../base-container.model';
import {bl_del_logistic_hub_link_RowClass} from '../../../../dbschema';
import * as fromDatatype from "../../../../datatype-library/index";


export class DeliveryLogisticHubNetworkGuidDto extends BaseContainerModel {
    networkHdrGuids: fromDatatype.GuidDataFieldInterface[][] = [];
}
